import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
// Import UI Components
import { Checkbox, Label, Tooltip } from '@geneui/components';
// Import Component
import CJCascadeDropdown from '../CJCascadeDropdown';
// Import Constants
import { CJArgumentValuesTypes } from 'constants/common';

const DynamicVariableOption = ({
    label,
    elements,
    option,
    node,
    getUpdate,
    getValidationUpdate,
    data,
    defaultValue,
}) => {
    const isChecked = defaultValue?.isChecked || false;
    const property = defaultValue?.value || null;

    const checkboxChangeHandler = useCallback(() => {
        const newIsChecked = !isChecked;
        getUpdate({ isChecked: newIsChecked, value: property });
    }, [isChecked, property, getUpdate]);

    const propertyChangeHandler = useCallback(
        (e) => {
            const newProperty = {
                blockId: e?.parentValue,
                propertyName: e?.value,
                logicFunction: e?.logicFunction,
                argumentInType: CJArgumentValuesTypes.ReferenceInArgument,
            };
            getUpdate({ isChecked: isChecked, value: newProperty });
        },
        [isChecked, getUpdate],
    );

    const toCascadeDropdownValue = (prop) => ({
        parentValue: prop?.blockId,
        value: prop?.propertyName,
        logicFunction: prop?.logicFunction,
    });

    return (
        <div className="crm-template-dynamic-variable">
            <div className="crm-template-item-label-container">
                <Tooltip text={label}>
                    <Label>{label}</Label>
                </Tooltip>
                <Checkbox checked={isChecked} onChange={checkboxChangeHandler} />
            </div>
            <div className="crm-cj-template-filter-condition-inputs-right-content">
                <CJCascadeDropdown
                    isDisabled={!isChecked}
                    value={toCascadeDropdownValue(property)}
                    data={data}
                    onChange={propertyChangeHandler}
                    option={{
                        ModelRelationScope: option?.ModelRelationScope,
                        SelfModelTypeName: option?.SelfModelTypeName,
                        SelfModelProperties: option?.SelfModelProperties,
                    }}
                    node={node}
                    elements={elements}
                    onValidationChange={getValidationUpdate}
                />
            </div>
        </div>
    );
};

DynamicVariableOption.propTypes = {
    label: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired,
    defaultValue: PropTypes.shape({
        isChecked: PropTypes.bool,
        value: PropTypes.any,
    }),
    node: PropTypes.object.isRequired,
    elements: PropTypes.array.isRequired,
    option: PropTypes.object.isRequired,
    getUpdate: PropTypes.func,
    getValidationUpdate: PropTypes.func,
};

DynamicVariableOption.defaultProps = {
    getUpdate: noop,
    getValidationUpdate: noop,
    defaultValue: { isChecked: false, value: null },
};

export default DynamicVariableOption;
